// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2aJjA","header":"MessagesList_header__2UDOI","chat":"MessagesList_chat__1AxFl"};